
//create, update, 
export class ActivityMapRequest{
    name: string;
    key:string;
    
}

export class AcitivityMapRequestFind{
    pageNumber: number;
    pageSize: number;
    
}
